import './components/styles/Input.js';
import { TimeWrapper, TimeSeparatorContainer } from './components/styles/Time.js';
import './components/styles/Select.js';
import './components/styles/Field.js';
import './components/styles/Password.js';
import WrappedFieldWrapper from './components/FieldWrapper.js';
import { Inline, InlineSize } from '@doordash/design-language';
import React__default from 'react';
import Select from './Select.js';
import { TimeFieldSize, TimeFieldMinuteInterval, HOURS, MINUTES, PERIODS } from './constants.js';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TimeField = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TimeField, _React$PureComponent);

  var _super = _createSuper(TimeField);

  function TimeField(props) {
    var _this;

    _classCallCheck(this, TimeField);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (_ref) {
      var _ref$hour = _ref.hour,
          hour = _ref$hour === void 0 ? _this.state.hour : _ref$hour,
          _ref$minute = _ref.minute,
          minute = _ref$minute === void 0 ? _this.state.minute : _ref$minute,
          _ref$period = _ref.period,
          period = _ref$period === void 0 ? _this.state.period : _ref$period;

      _this.setState({
        hour: hour,
        minute: minute,
        period: period
      }, function () {
        _this.props.onChange(_this.state);
      });
    });

    _this.state = _objectSpread({}, props.value);
    return _this;
  }

  _createClass(TimeField, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value.hour !== this.props.value.hour || prevProps.value.minute !== this.props.value.minute || prevProps.value.period !== this.props.value.period) {
        this.setState(_objectSpread({}, this.props.value));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          label = _this$props.label,
          description = _this$props.description,
          hint = _this$props.hint,
          error = _this$props.error,
          id = _this$props.id,
          isDisabled = _this$props.isDisabled,
          isLabelHidden = _this$props.isLabelHidden,
          isRounded = _this$props.isRounded,
          onClick = _this$props.onClick,
          renderBeforeContent = _this$props.renderBeforeContent,
          renderAfterContent = _this$props.renderAfterContent,
          _this$props$minuteInt = _this$props.minuteInterval,
          minuteInterval = _this$props$minuteInt === void 0 ? TimeFieldMinuteInterval.Fifteen : _this$props$minuteInt,
          _this$props$size = _this$props.size,
          size = _this$props$size === void 0 ? TimeFieldSize.Medium : _this$props$size;
      return /*#__PURE__*/React__default.createElement(WrappedFieldWrapper, {
        label: label,
        description: description,
        hint: hint,
        error: error,
        isDisabled: isDisabled,
        isLabelHidden: isLabelHidden,
        renderBeforeContent: renderBeforeContent,
        renderAfterContent: renderAfterContent,
        isBare: true,
        size: size,
        onClick: onClick,
        id: id
      }, /*#__PURE__*/React__default.createElement(TimeWrapper, {
        "aria-label": label,
        "aria-disabled": isDisabled ? true : undefined,
        role: 'group'
      }, /*#__PURE__*/React__default.createElement(Inline, {
        size: InlineSize.XSmall
      }, /*#__PURE__*/React__default.createElement(Select, {
        value: this.state.hour,
        label: "Hour",
        isLabelHidden: true,
        isDisabled: isDisabled,
        isRounded: isRounded,
        disabledValue: "HH",
        options: HOURS,
        onChange: function onChange(hour) {
          return _this2.handleChange({
            hour: hour
          });
        },
        size: size,
        error: typeof error === 'boolean' ? error : error && error.length > 0
      })), /*#__PURE__*/React__default.createElement(TimeSeparatorContainer, {
        size: InlineSize.XSmall
      }, ":"), /*#__PURE__*/React__default.createElement(Inline, null, /*#__PURE__*/React__default.createElement(Select, {
        value: this.state.minute,
        label: "Minute",
        isLabelHidden: true,
        isDisabled: isDisabled,
        isRounded: isRounded,
        disabledValue: "MM",
        options: MINUTES[minuteInterval],
        onChange: function onChange(minute) {
          return _this2.handleChange({
            minute: minute
          });
        },
        size: size,
        error: typeof error === 'boolean' ? error : error && error.length > 0
      })), /*#__PURE__*/React__default.createElement(Select, {
        value: this.state.period,
        label: "Period",
        isLabelHidden: true,
        isDisabled: isDisabled,
        isRounded: isRounded,
        disabledValue: "--",
        options: PERIODS,
        onChange: function onChange(period) {
          return _this2.handleChange({
            period: period
          });
        },
        size: size,
        error: typeof error === 'boolean' ? error : error && error.length > 0
      })));
    }
  }]);

  return TimeField;
}(React__default.PureComponent);

_defineProperty(TimeField, "MinuteIntervals", TimeFieldMinuteInterval);

_defineProperty(TimeField, "defaultProps", {
  size: TimeFieldSize.Medium,
  minuteInterval: TimeFieldMinuteInterval.Fifteen
});

_defineProperty(TimeField, "Sizes", TimeFieldSize);

export { TimeField as default };
